import { Case } from '../../../beans/Case';
import { Nomenclature } from '../../../beans/Nomenclature';
import { Lawyer } from '../../../beans/Lawyer';
import { Person } from '../../../beans/Person';
import { FrxBaseBean } from '../../../beans/frxbasebean';
import { WordTemplate } from '../../../beans/word-template';
import { AuthService } from '../../../services/auth.service';
import { BlockUiService } from '../../../services/blockui.service';
import { CaseService } from '../../../services/case.service';
import { NomenclatureService } from '../../../services/nomenclature.service';
import { PersonService } from '../../../services/person.service';
import { WordTemplateService } from '../../../services/word-template.service';
import { UserPreferencesService } from '../../../services/user-preferences.service';
import { EditCaseComponent } from '../edit-case.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ViewContainerRef, Host, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-edit-case-main',
	templateUrl: './edit-case-main.component.html',
	styleUrls: ['./edit-case-main.component.scss']
})
export class EditCaseMainComponent implements OnInit {

	@ViewChild('editPerson') editPerson;

	@Output() closeRequested = new EventEmitter<void>();

	errorMessage = '';
	saving = false;
	_editedCase: Case;

	claimant: Person;
	defendant: Person;
	helper: Person;
	dead: Person;

	editedPerson = new Person();

	// Loaded object lsits bellow
	lawyers: Array<Lawyer>;
	damageTypes: Array<Nomenclature>;
	traumaType: Array<Nomenclature>;
	vidSluchaj: Array<Nomenclature>;

	// Word templates
	deloTemplates: WordTemplate[] = [];
	selectedDeloTemplate: WordTemplate = null;

	currentUserIsAdmin: boolean = false;

	// Reopen flow: snapshot-ваме prikljucheno стойността при отваряне на формата,
	// за да усетим TRUE→FALSE преход. Когато се случи — показваме модала.
	prikljuchenoAtOpen: boolean = false;
	showReopenModal: boolean = false;
	reopenExplanationText: string = '';

	// Warning при отваряне на приключено дело: показваме веднъж при load.
	showPrikljuchenWarning: boolean = false;

	constructor(
		private caseService: CaseService,
		private nomenclatureService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private personService: PersonService,
		private datePipe: DatePipe,
		private wordTemplateService: WordTemplateService,
		private authService: AuthService,
		private prefsService: UserPreferencesService
	) {
		this.currentUserIsAdmin = this.authService.isUserAdmin();
	}

	ngOnInit() {
		this.loadLawyers();
		this.loadDamageTypes();
		this.loadTraumaTypes();
		this.loadVidSluchaj();
		this.loadDeloTemplates();
	}

	private loadVidSluchaj() {
		this.vidSluchaj = new Array<Nomenclature>();
		this.nomenclatureService.getVidSluchaj().subscribe(types => {
			this.vidSluchaj = types;
		});
	}

	private loadDeloTemplates() {
		this.wordTemplateService.findByType('DELO').subscribe(
			data => this.deloTemplates = data.filter(t =>
				!t.placeholderCategories ||
				(!t.placeholderCategories.includes('GRAZHDANSKA_INSTANCIJA') &&
				 !t.placeholderCategories.includes('NAKAZATELNO') &&
				 !t.placeholderCategories.includes('IZPULNITELNO'))
			),
			err => { }
		);
	}

	generateDocument() {
		if (!this.selectedDeloTemplate || !this._editedCase || !this._editedCase.id) return;
		this.blockUi.start(this.vcRef);
		this.wordTemplateService.generateDocument(this.selectedDeloTemplate.id, this._editedCase.id).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = this.selectedDeloTemplate.name + '_generated.docx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				alert('Грешка при генериране на документ');
			}
		);
	}


	private loadDamageTypes() {
		this.damageTypes = new Array<Nomenclature>();
		this.nomenclatureService.getDamageTypes().subscribe(types => {
			this.damageTypes = types;
		});
	}

	private loadTraumaTypes() {
		this.traumaType = new Array<Nomenclature>();
		this.nomenclatureService.getTraumaTypes().subscribe(types => {
			this.traumaType = types;
		});
	}

	private loadLawyers() {
		this.lawyers = new Array<Lawyer>();
		this.nomenclatureService.getLawyers().subscribe(
			lawyers => {
				this.lawyers = lawyers;
			});
	}

	@Input()
	public set editedCase(val: Case) {
		this.editCase(val);
	}

	public get editedCase() {
		return this._editedCase;
	}

	public editCase(caseObj: Case): void {
		this.refreshCase();
		this.errorMessage = '';
		if (caseObj && caseObj.id) {
			this._editedCase.copy(caseObj);
		}
		this.prikljuchenoAtOpen = !!(caseObj && caseObj.prikljucheno);
		this.reopenExplanationText = '';
		this.showReopenModal = false;

		// Предупреждаваме (включително колегите-адвокати) при отваряне
		// на приключено дело — но само ПЪРВИТЕ 2 пъти ЗА ТОВА КОНКРЕТНО ДЕЛО.
		// Броенето се пази per-дело в user.preferences.ui.prikljuchenoWarningSeen
		// (map lawsuiteId → count), в DB-то — следва потребителя навсякъде.
		const dealId = caseObj && caseObj.id ? String(caseObj.id) : null;
		if (this.prikljuchenoAtOpen && dealId) {
			const prefs = this.prefsService.current();
			const seen = (prefs.ui && prefs.ui.prikljuchenoWarningSeen) || {};
			const count = seen[dealId] || 0;
			this.showPrikljuchenWarning = count < 2;
			if (this.showPrikljuchenWarning) {
				const updatedSeen = { ...seen, [dealId]: count + 1 };
				this.prefsService.patch({
					ui: { prikljuchenoWarningSeen: updatedSeen }
				}).subscribe();
			}
		} else {
			this.showPrikljuchenWarning = false;
		}
	}

	dismissPrikljuchenWarning() {
		this.showPrikljuchenWarning = false;
	}

	requestClose() {
		this.closeRequested.emit();
	}

	/** Превежда reason кода в четим български етикет. */
	prikljuchenReasonLabel(code: string): string {
		switch (code) {
			case 'АРХИВ_В_ПАПКА': return 'Архивна папка / архивен статус';
			case 'СПОРАЗУМЕНИЕ_БЕЗ_ДВИЖЕНИЕ': return 'Споразумение без движение';
			case 'БЕЗ_ОТГОВОРНИК_4Г': return 'Без отговорник 4+ години';
			case 'РЪЧНО': return 'Ръчно от потребител';
			case 'НЕИЗВЕСТНО': return 'Неизвестна (legacy)';
			default: return code || '';
		}
	}

	/** ngModelChange hook за prikljucheno чекбокса. */
	onPrikljuchenoToggle(newVal: boolean) {
		if (this.prikljuchenoAtOpen && !newVal) {
			// Опит за отваряне на приключено дело → искаме обяснение.
			// Първо връщаме чекбокса на TRUE, докато admin не потвърди в модала.
			this.editedCase.prikljucheno = true;
			this.reopenExplanationText = '';
			this.showReopenModal = true;
		}
	}

	confirmReopen() {
		const expl = (this.reopenExplanationText || '').trim();
		if (!expl) {
			alert('Моля, въведете обяснение защо отваряте делото.');
			return;
		}
		this.editedCase.prikljucheno = false;
		this.editedCase.reopenExplanation = expl;
		this.showReopenModal = false;
	}

	cancelReopen() {
		// Връщаме чекбокса в чекнато състояние — не сме отворили делото.
		this.editedCase.prikljucheno = true;
		this.editedCase.reopenExplanation = null;
		this.reopenExplanationText = '';
		this.showReopenModal = false;
	}

	public reset(caseObj): void {
		this._editedCase = new Case();
		if (caseObj) {
			this._editedCase = caseObj;
		}
	}

	prepareCaseDto(caseObj: Case) : any{
		return {
			...caseObj,

			// ДАТИ → backend must receive YYYY-MM-DD
			date: this.caseService.toBackendIsoDate(caseObj.date),
			claimDate: this.caseService.toBackendIsoDate(caseObj.claimDate),

		};
	}

	saveCase() {
		if (this.saving) {
			return;
		}
		this.saving = true;
		this.errorMessage = '';
		this.blockUi.start(this.vcRef);

		// Запомняме дали редактираме съществуващо дело — при редакция
		// затваряме прозореца след запис. При НОВО дело го оставяме отворен,
		// за да може потребителят да продължи (инстанции, разноски и т.н.).
		const wasExisting = this.editedCase.id != null;

		try {
			let dto = this.prepareCaseDto(this.editedCase);

			this.caseService.saveCase(dto, this.editedCase.id != null).subscribe(
				result => {
					this.saving = false;
					this.blockUi.stop();
					if (wasExisting) {
						this.requestClose();
					} else {
						alert('Делото беше записано успешно');
					}
				},
				error =>  {
					this.saving = false;
					this.blockUi.stop();
					let msg = 'Грешка при запис';
					if (error) {
						if (error.error && error.error.message) {
							msg += ': ' + error.error.message;
						} else if (error.message) {
							msg += ': ' + error.message;
						} else if (error.status) {
							msg += ' (HTTP ' + error.status + (error.statusText ? ' ' + error.statusText : '') + ')';
						}
					}
					this.errorMessage = msg;
					alert(msg);
				}
			);

		} catch (error) {
			this.saving = false;
			this.errorMessage = 'Грешен формат на дата';
			this.blockUi.stop();
			alert(this.errorMessage);
		}
	}


	refreshCase() {
		this.errorMessage = '';
		this._editedCase = new Case();
		this.claimant = new Person();
		this.defendant = new Person();
		this.dead = new Person();
		this.helper = new Person();
		this._editedCase.claimentList = new Array<Person>();
		this._editedCase.defendantList = new Array<Person>();
		this._editedCase.helpersList = new Array<Person>();

	}


	observableSource(keyword: string): any {
		return this.personService.searchPersons(keyword);
	}

	addClaiment() {
		this.addPersonToList(this.claimant, 'claimentList');
	}


	addDefendant() {
		this.addPersonToList(this.defendant, 'defendantList');
	}

	addDead() {
		this.addPersonToList(this.dead, 'deadList');
	}

	addHelper() {
		this.addPersonToList(this.helper, 'helpersList');
	}

	addPersonToList(person: Person, listName: string) {
		if (person && person.id && this._editedCase[listName]) {
			this._editedCase[listName].push(person);
		}
	}

	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}


	reloadPersons(person: Person, callbackListName: string) {
		switch (callbackListName) {
			case 'claimentList': this.removeClaiment(this.editedPerson); break;
			case 'defendantList': this.removeDefendant(this.editedPerson); break;
			case 'deadList': this.removeDead(this.editedPerson); break;
			case 'helpersList': this.removeHelper(this.editedPerson); break;
		}
		this.addPersonToList(person, callbackListName);
	}

	removeClaiment(person) {
		this.removePersonFromList(person, this._editedCase.claimentList);
	}
	removeDefendant(person) {
		this.removePersonFromList(person, this._editedCase.defendantList);
	}

	removeDead(person) {
		this.removePersonFromList(person, this._editedCase.deadList);
	}
	removeHelper(person) {
		this.removePersonFromList(person, this._editedCase.helpersList);
	}
	editClaiment(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'claimentList');
	}
	editDefendant(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'defendantList');
	}
	editDead(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'deadList');
	}
	editHelper(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'helpersList');
	}
	removePersonFromList(person: Person, list: Array<Person>) {
		const index = list.findIndex(i => i.id === person.id);
		if (index > -1) {
			list = list.splice(index, 1);
		}
	}

	getCurrentComponent() {
		return this;
	}
}
